export class ApiError extends Error {
  status: number;
  url?: string;

  constructor(response: { status: number; message?: string; url?: string }) {
    super(response.message);
    Object.assign(this, response);
    this.url = response.url?.split('?')[0];
    this.name = `ApiError ${response.status}`;
  }
}
